import { FillMode } from '@src/slide/infrastructure/module/dependent/shape-info/constant';
import { gradientColorExtendsAlpha } from '@src/slide/infrastructure/module/independent/color/transform';

const COLOR_LEV1 = 0.193;
const COLOR_LEV2 = 0.398;

/**
 * 根据 fillMode 生成新的填充颜色
 * @param orgColor
 * @param fillMode
 */
export function generateColorWithFillMode(orgColor: string, fillMode: number): string {
    let color = orgColor;
    switch (fillMode) {
        case FillMode.NONE:
            color = '#ffffff00';  // 背景透明
            break;
        case FillMode.NORMAL:
            break;
        case FillMode.BRIGHT:
            color = gradientColorExtendsAlpha(orgColor, 'rgb(255,255,255)', COLOR_LEV1);
            break;
        case FillMode.BRIGHTER:
            color = gradientColorExtendsAlpha(orgColor, 'rgb(255,255,255)', COLOR_LEV2);
            break;
        case FillMode.DARK:
            color = gradientColorExtendsAlpha(orgColor, 'rgb(0,0,0)', COLOR_LEV1);
            break;
        case FillMode.DARKER:
            color = gradientColorExtendsAlpha(orgColor, 'rgb(0,0,0)', COLOR_LEV2);
            break;
    }
    return color;
}

export function getScaleInfo(path, model) {
    let pathWidth = path?.width || model.width * 12700;
    let pathHeight = path?.height || model.height * 12700;
    if (pathWidth === 0) pathWidth = 1;
    if (pathHeight === 0) pathHeight = 1;
    let scaleW = model.width / pathWidth;
    let scaleH = model.height / pathHeight;
    if (scaleW === 0) scaleW = 1 / 12700;
    if (scaleH === 0) scaleH = 1 / 12700;
    const tranStr = `scale(${scaleW} ${scaleH})`;
    return { scaleW, scaleH, tranStr };
}

export function getFillMode(path, isCustom: boolean): number {
    let fillMode = FillMode.NORMAL;
    if (!isCustom && path?.fillMode) {
        fillMode = path?.fillMode;
    }
    return fillMode;
}

/**
 * 不随形状旋转
 * @param rotateWithShape
 */
export function notRotateWithShape(rotateWithShape): boolean {
    const hasRotateWithShape = typeof (rotateWithShape) !== 'undefined';
    return hasRotateWithShape && rotateWithShape === 0;
}

